import React, { Fragment, useState } from 'react';
//-----------------------------------------------------------------------------
import './style.scss';

export const FadeInImage = ({
  imageAlt,
  imageSrc,
  styles,
  classNames = [],
  width = '256',
  height = '144',
  onClick=() => {},
}) => {
  const [opacity, setOpacity] = useState(0);

  const handleImageLoad = () => {
    setOpacity(1);
  };

  return (
    <Fragment>
      {opacity === 0 && null}
      <img
        className={[...classNames, 'fade-in-image'].join(' ')}
        src={imageSrc}
        alt={imageAlt}
        loading="lazy"
        decoding="async"
        lazyalt="clarovideo poster"
        onLoad={handleImageLoad}
        style={{ ...styles, opacity }}
        width={width}
        height={height}
        onClick={onClick}
      />
    </Fragment>
  );
};

export default FadeInImage;
